import { useIsClusterDemoMode } from '@cast/infrastructure-demo';

import { useCanViewWoop } from './useCanViewWoop';
import { useWoopAgent } from './useWoopAgent';

export const useIsWoopDemoMode = () => {
  const canView = useCanViewWoop();
  const { isWoopAgentInstalled } = useWoopAgent();
  const isClusterDemoMode = useIsClusterDemoMode();

  // demo cluster or woop ff disabled or woop component not installed
  return isClusterDemoMode || !canView || !isWoopAgentInstalled;
};
